<template>
	<v-sheet class="inventory" style="height: calc(100vh - 88px)">
		<template v-if="contentLoaded">
			<v-layout class="align-center light-blue-bg px-4 py-2">
				<v-flex md12>
					<v-layout class="justify-content-between align-items-center">
						<v-flex>
							<p class="my-auto font-level-3-bold">
								<span class="fw-500">
									<b class="text-truncate d-inline-block" style="max-width: 42%; vertical-align: middle">
										<ShowValue :object="inventory" object-key="name" label="inventory name"></ShowValue>
									</b>
									<v-chip color="cyan" class="ml-2 mr-2" label text-color="white">{{
										inventory.barcode
									}}</v-chip>
									<template v-if="inventory.is_fault == 1">
										<v-chip color="#1bc5bd" text-color="white" label class="mr-2"> Fault </v-chip>
									</template>
									<template v-if="inventory.retired == 1">
										<v-chip color="#F44336" text-color="white" label> RETIRED </v-chip>
									</template>
									<template v-else-if="inventory.activated == 1">
										<v-chip color="#4CAF50" text-color="white" label> ACTIVE </v-chip>
									</template>
									<template v-else-if="inventory.activated == 0">
										<v-chip color="#F44336" text-color="white" label> INACTIVE </v-chip>
									</template>
								</span>
							</p>
						</v-flex>
						<v-flex md7 class="text-right">
							<template v-if="false && inventory.retired">
								<v-btn
									v-on:click="doAction('stock-history')"
									color="blue darken-4 text-white"
									class="mx-2"
									depressed
									tile
									><v-icon small left>mdi-history</v-icon>Stock History</v-btn
								>
								<v-btn
									v-on:click="doAction('print-label')"
									color="blue darken-4 text-white"
									class="mx-2"
									depressed
									tile
									><v-icon small left>mdi-printer</v-icon>Print Label</v-btn
								>
							</template>
							<template v-else>
								<v-menu offset-y left bottom content-class="elevation-3" rounded="0">
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											color="blue darken-4 text-white"
											v-on="on"
											v-bind="attrs"
											class="mr-2"
											depressed
											tile
											><v-icon small left>mdi-more mdi-flip-h</v-icon>More</v-btn
										>
									</template>
									<v-list>
										<v-list-item v-if="false" v-on:click="doAction('stock-history')">
											<v-list-item-title>
												<v-icon small left color="blue darken-4">mdi-history</v-icon>
												Stock History</v-list-item-title
											>
										</v-list-item>
										<v-list-item v-if="false" v-on:click="doAction('print-label')">
											<v-list-item-title>
												<v-icon small left color="blue darken-4">mdi-printer</v-icon>
												Print Label</v-list-item-title
											>
										</v-list-item>
										<v-list-item
											v-if="inventory.retired == 0 && getPermission('inventory:update')"
											v-on:click="doAction('edit')"
										>
											<v-list-item-title>
												<v-icon small left color="blue darken-4">mdi-pencil</v-icon>
												Edit
											</v-list-item-title>
										</v-list-item>
										<v-list-item v-if="getPermission('inventory:create')" v-on:click="doAction('duplicate')">
											<v-list-item-title>
												<v-icon small left color="blue darken-4">mdi-content-duplicate</v-icon>
												Clone
											</v-list-item-title>
										</v-list-item>
										<v-list-item v-if="getPermission('inventory:delete')" v-on:click="doAction('delete')">
											<v-list-item-title>
												<v-icon small left color="blue darken-4">mdi-delete</v-icon>
												Delete
											</v-list-item-title>
										</v-list-item>
										<!-- Used In responsive -->
										<template>
											<template v-if="!inventory.retired && inventory.initial_stock > 0">
												<v-list-item v-if="getPermission('checkout:create')" v-on:click="doAction('checkout')">
													<v-list-item-title>
														<v-icon small left color="blue darken-4">mdi-share-outline</v-icon>
														Issue
													</v-list-item-title>
												</v-list-item>
												<v-list-item
													v-if="getPermission('inventory:update')"
													v-on:click="doAction('retire-stock')"
												>
													<v-list-item-title>
														<v-icon small left color="blue darken-4">mdi-cancel</v-icon>
														Retire Stock
													</v-list-item-title>
												</v-list-item>
												<v-list-item v-if="getPermission('inventory:update')" v-on:click="doAction('retire')">
													<v-list-item-title>
														<v-icon small left color="blue darken-4">mdi-cancel</v-icon>
														Retire
													</v-list-item-title>
												</v-list-item>
											</template>
										</template>
									</v-list>
								</v-menu>
								<template>
									<template v-if="!inventory.retired && inventory.initial_stock > 0">
										<v-btn
											v-if="getPermission('checkout:create')"
											v-on:click="doAction('checkout')"
											color="blue darken-4 text-white"
											class="mx-2"
											depressed
											tile
										>
											<v-icon small left>mdi-share-outline</v-icon>Issue
										</v-btn>
										<v-btn
											v-if="getPermission('inventory:update')"
											v-on:click="doAction('retire-stock')"
											color="blue darken-4 text-white"
											class="ml-2"
											depressed
											tile
											><v-icon small left>mdi-cancel</v-icon>Retire Stock</v-btn
										>
										<v-btn
											v-if="getPermission('inventory:update')"
											v-on:click="doAction('retire')"
											color="blue darken-4 text-white"
											class="ml-2"
											depressed
											tile
											><v-icon small left>mdi-cancel</v-icon>Retire</v-btn
										>
									</template>
									<v-btn
										v-if="false"
										v-on:click="doAction('reserve')"
										color="blue darken-4 text-white"
										class="ml-2"
										depressed
										tile
										><v-icon small left>mdi-calendar-check</v-icon>Reserve</v-btn
									>
								</template>
								<v-btn
									v-if="inventory.retired == 0 && getPermission('inventory:update')"
									v-on:click="doAction('add-stock')"
									color="blue darken-4 text-white"
									class="mx-2"
									depressed
									tile
									><v-icon small left>mdi-playlist-plus</v-icon>Add Stock</v-btn
								>
							</template>
						</v-flex>
					</v-layout>
					<div class="d-flex mt-4">
						<div class="w-10 pr-3">
							<ImageTemplate circle :src="inventory.image"></ImageTemplate>
						</div>
						<div class="w-100 pr-3">
							<div v-if="inventory.pico_barcode && inventory.barcode_image" style="max-width: 300px">
								<div class="d-inline-block text-center">
									<img
										style="max-width: 100%; height: 30px"
										:src="inventory.barcode_image"
										:alt="inventory.pico_barcode"
									/>
									<pre class="mb-0 barcode-text bold-700">{{ inventory.pico_barcode }}</pre>
								</div>
							</div>
							<div class="d-flex mt-4">
								<div class="w-33">
									<div class="mt-2">
										<span class="fw-600">Perishables # : </span>
										<span class="fw-500 no-wrap no-wrap">
											<ShowValue :object="inventory" object-key="barcode" label="inventory #"></ShowValue>
										</span>
									</div>
								</div>
								<div class="w-33">
									<div class="mt-2">
										<span class="fw-600">Contact for Item : </span>
										<span class="fw-500 no-wrap">
											<ShowValue :object="inventory" object-key="contact" label="contact for item"></ShowValue>
										</span>
									</div>
								</div>
								<div class="w-33">
									<div class="mt-2">
										<span class="fw-600"> Category : </span>
										<span class="fw-500 no-wrap">
											<ShowValue :object="inventory" object-key="group_relation.name" label="Category">
											</ShowValue>
										</span>
									</div>
								</div>
							</div>
							<div class="d-flex">
								<div class="w-33">
									<div class="mt-2">
										<span class="fw-600 mr-2">Supplier : </span>
										<span class="fw-500">
											<span class="fw-500 no-wrap">
												<ShowValue
													:object="inventory"
													object-key="supplier_relation.display_name"
													label="supplier"
												></ShowValue>
											</span>
										</span>
									</div>
								</div>
								<div class="w-33">
									<div class="mt-2">
										<span class="fw-600 mr-2">Stock Level : </span>
										<span class="fw-500 no-wrap">
											<ShowValue
												:object="inventory"
												object-key="initial_stock_formatted"
												label="Stock Level"
											></ShowValue>
										</span>
									</div>
								</div>
								<div class="w-33">
									<div class="mt-2">
										<span class="fw-600"> Reorder Quantity : </span>
										<span class="fw-500 no-wrap">
											<ShowValue
												:object="inventory"
												object-key="reorder_quantity_formatted"
												label="reorder quantity"
											></ShowValue>
										</span>
									</div>
								</div>
							</div>
							<div class="d-flex">
								<div class="w-33">
									<div class="mt-2">
										<span class="fw-600">Add Stock Price : </span>
										<span class="fw-500 no-wrap">
											<ShowValue
												:object="inventory"
												object-key="price_add_stock_formatted"
												label="add stock price"
											></ShowValue>
										</span>
									</div>
								</div>
								<div class="w-33">
									<div class="mt-2">
										<span class="fw-600">Barcode : </span>
										<span class="fw-500 no-wrap">
											<ShowValue :object="inventory" object-key="pico_barcode" label="barcode"> </ShowValue>
										</span>
									</div>
								</div>
								<div class="w-33">
									<div class="mt-2">
										<span class="fw-600">Password : </span>
										<span class="fw-500 no-wrap">
											<ShowValue :object="inventory" object-key="password" label="password"> </ShowValue>
										</span>
									</div>
								</div>
							</div>
						</div>
						<!-- <div class="w-20 pr-3" v-if="inventory.pico_barcode && inventory.barcode_image">
							<div class="mt-2">
								<span class="fw-600">Pico Barcode : </span>
								<span class="fw-500">
									<Barcode circle :src="inventory.barcode_image"></Barcode>
								</span>
							</div>
						</div> -->
					</div>
				</v-flex>
			</v-layout>
			<div>
				<v-tabs
					v-model="inventoryTab"
					background-color="transparent"
					color="blue"
					class="custom-tab-transparent"
					active-class="blue darken-4 text-white"
					hide-slider
				>
					<v-tab href="#detail">
						<v-icon small left>mdi-format-list-bulleted-square</v-icon> Details</v-tab
					>
					<v-tab href="#quantity-by-location" v-if="false">
						<v-icon small left>mdi-map-marker-outline</v-icon> Quantity by Location</v-tab
					>
					<v-tab v-if="false" href="#reservation">
						<v-icon small left>mdi-calendar-check</v-icon> Reservations</v-tab
					>
					<v-tab href="#retire_stock_records" class="pr-8">
						<v-icon small left>mdi-calendar-check</v-icon>
						<v-badge color="cyan" :content="inventoryRetire"> Retire Stock Recordes </v-badge>
					</v-tab>
					<v-tab href="#event" class="pr-8">
						<v-icon small left>mdi-history</v-icon>
						<v-badge color="cyan" :content="inventoryLog"> Logs </v-badge>
					</v-tab>
					<v-tab href="#related-service" v-if="false">
						<v-icon small left>mdi-hammer-wrench</v-icon> Related Services</v-tab
					>
					<v-tab v-if="false" href="#work-order">
						<v-icon small left>mdi-clipboard-list</v-icon> Work Orders</v-tab
					>
					<v-tab v-if="getPermission('inventory:update')" href="#file" class="pr-8">
						<v-icon small left>mdi-file-document-multiple</v-icon>
						<v-badge color="cyan" :content="inventoryFile"> Files </v-badge>
					</v-tab>
					<v-tab v-if="getPermission('inventory:update')" href="#comment" class="pr-8">
						<v-icon small left>mdi-comment-multiple</v-icon>
						<v-badge color="cyan" :content="inventorycomment"> Comments </v-badge>
					</v-tab>
					<v-tab v-if="false" href="#support">
						<v-icon small left>mdi-page-next-outline</v-icon> Support</v-tab
					>
				</v-tabs>

				<v-tabs-items v-model="inventoryTab">
					<v-tab-item value="detail">
						<div class="mx-4">
							<div class="overflow-y" style="max-height: calc(100vh - 250px)">
								<v-layout class="p-4 border-bottom-light-grey min-height-57px">
									<v-flex class="font-level-3-bold my-auto">
										<span class="detail-svg-icon mr-2">
											<!--begin::Svg Icon-->
											<inline-svg :src="$assetURL('media/custom-svg/inventory-color.svg')" />
											<!--end::Svg Icon-->
										</span>
										Perishables Details
									</v-flex>
								</v-layout>
								<table width="100%" class="detail-table scattered-table">
									<tr>
										<th width="300px">Purchased On</th>
										<td>
											<ShowValue
												:object="inventory"
												object-key="purchased_on_formatted"
												label="purchased on"
											></ShowValue>
										</td>
									</tr>
									<tr>
										<th width="300px">Description</th>
										<td>
											<ShowValue :object="inventory" object-key="description" label="description"></ShowValue>
										</td>
									</tr>
									<tr v-if="false">
										<th width="300px">Sub Group</th>
										<td>
											<ShowValue
												:object="inventory"
												object-key="sub_group_relation.name"
												label="sub group"
											></ShowValue>
										</td>
										<th width="300px">Total Quantity</th>
										<td>
											<ShowValue
												:object="inventory"
												object-key="total_quantity"
												label="total quantity"
											></ShowValue>
										</td>
									</tr>
									<tr v-if="false">
										<th width="300px">Identification Number</th>
										<td>
											<ShowValue
												:object="inventory"
												object-key="id_number"
												label="identification number"
											></ShowValue>
										</td>
										<th width="300px">Available Quantity</th>
										<td>
											<ShowValue
												:object="inventory"
												object-key="available_quantity"
												label="available quantity"
											></ShowValue>
										</td>
									</tr>
									<tr v-if="false">
										<th>
											Low Stock Threshold
											<TooltipQuestion>
												<template v-slot:text
													>You will receive an email alert<br />when the total stock quantity<br />becomes less
													than this value</template
												>
											</TooltipQuestion>
										</th>
										<td>
											<ShowValue
												:object="inventory"
												object-key="low_stock_formatted"
												label="low stock threshold"
											></ShowValue>
										</td>
										<th width="300px">
											Remove Stock Price
											<TooltipQuestion>
												<template v-slot:text>Default price for remove stock</template>
											</TooltipQuestion>
										</th>
										<td>
											<ShowValue
												:object="inventory"
												object-key="price_remove_stock_formatted"
												label="remove stock price"
											></ShowValue>
										</td>
									</tr>
									<tr v-if="false">
										<th>
											Default Low Location Threshold
											<TooltipQuestion>
												<template v-slot:text
													>For all locations without specified<br />thresholds, you will receive an<br />email
													alert when stock<br />quantity falls below this value</template
												>
											</TooltipQuestion>
										</th>
										<td>
											<ShowValue
												:object="inventory"
												object-key="default_threshold_relation.low_location_formatted"
												label="default low location threshold"
											></ShowValue>
										</td>
										<th>
											Default Excess Location Threshold
											<TooltipQuestion>
												<template v-slot:text
													>For all locations without specified<br />thresholds, you will receive an<br />email
													alert when stock<br />quantity is higher than this value</template
												>
											</TooltipQuestion>
										</th>
										<td>
											<ShowValue
												:object="inventory"
												object-key="default_threshold_relation.excess_location_formatted"
												label="default excess location threshold"
											></ShowValue>
										</td>
									</tr>
									<tr v-if="false">
										<th>Default Location</th>
										<td colspan="3">
											<ShowValue
												:object="inventory"
												object-key="location_relation.name"
												label="default location"
											></ShowValue>
										</td>
									</tr>
								</table>
							</div>
						</div>
					</v-tab-item>
					<v-tab-item value="retire_stock_records">
						<ItemRetirementsListing
							v-if="inventoryTab == 'retire_stock_records'"
							class="mx-4"
							type-text="Inventory"
							type="inventory"
							:uuid="uuid"
						></ItemRetirementsListing>
					</v-tab-item>
					<v-tab-item value="quantity-by-location">
						<QuantityLocation
							v-if="inventoryTab == 'quantity-by-location'"
							class="mx-4"
							type-text="Perishables"
							type="inventory"
							:type-uuid="uuid"
						></QuantityLocation>
					</v-tab-item>
					<v-tab-item value="reservation">
						<ReservationListing
							v-if="inventoryTab == 'reservation'"
							class="mx-4"
							type-text="Perishables"
							type="inventory"
							:type-uuid="uuid"
						></ReservationListing>
					</v-tab-item>
					<v-tab-item value="event">
						<EventListing
							v-if="inventoryTab == 'event'"
							class="mx-4"
							type-text="Perishables"
							type="inventory"
							:type-uuid="uuid"
						></EventListing>
					</v-tab-item>
					<v-tab-item value="related-service" v-if="false">
						<RelatedServiceTemplate
							v-if="inventoryTab == 'related-service'"
							class="mx-4"
							type-text="Perishables"
							type="inventory"
							:type-uuid="uuid"
						></RelatedServiceTemplate>
					</v-tab-item>
					<v-tab-item value="work-order" v-if="false">
						<WorkOrderListing
							v-if="inventoryTab == 'work-order'"
							class="mx-4"
							type-text="Perishables"
							type="inventory"
							:type-uuid="uuid"
						></WorkOrderListing>
					</v-tab-item>
					<v-tab-item value="file">
						<Files
							v-if="inventoryTab == 'file'"
							class="mx-4"
							type-text="Perishables Files"
							type="inventory"
							:type-uuid="uuid"
						></Files>
					</v-tab-item>
					<v-tab-item value="comment">
						<Comments
							v-if="inventoryTab == 'comment'"
							class="mx-4"
							type-text="Perishables"
							type="inventory"
							:type-uuid="uuid"
						></Comments>
					</v-tab-item>
					<v-tab-item value="support">
						<SupportTemplate
							v-if="inventoryTab == 'support'"
							class="mx-4"
							type-text="Perishables"
							type="inventory"
							:type-uuid="uuid"
						></SupportTemplate>
					</v-tab-item>
				</v-tabs-items>
			</div>
			<DeleteTemplate
				type="Perishables"
				:delete-text="deleteText"
				v-on:success="goBack()"
				v-on:close="deleteDialog = false"
				:delete-dialog="deleteDialog"
				:delete-url="deleteURL"
				:delete-note="
					!inventory.retired
						? 'To preserve associated records, you could retire the Perishables instead.'
						: null
				"
			>
				<template v-if="!inventory.retired" v-slot:extra-btn>
					<v-btn
						class="white--text"
						depressed
						color="blue darken-4"
						tile
						v-on:click="
							deleteDialog = false;
							retireDialog = true;
						"
					>
						Retire
					</v-btn>
				</template>
			</DeleteTemplate>
			<template v-if="retireDialog">
				<RetireTemplate
					type="Inventory"
					endpoint="inventory"
					:type-uuid="uuid"
					v-on:success="goBack()"
					v-on:close="retireDialog = false"
					:retire-dialog="retireDialog"
				></RetireTemplate>
			</template>
			<template v-if="retireStockDialog">
				<RetireStockTemplate
					type="Inventory"
					endpoint="inventory"
					:type-uuid="uuid"
					v-on:success="goBack()"
					v-on:close="retireStockDialog = false"
					:retire-dialog="retireStockDialog"
				></RetireStockTemplate>
			</template>
			<template v-if="reservationDialog">
				<ReservationTemplate
					type="Inventory"
					endpoint="inventory"
					:type-uuid="uuid"
					v-on:success="
						reservationDialog = false;
						getInventory();
					"
					v-on:close="reservationDialog = false"
					:reservation-dialog="reservationDialog"
				></ReservationTemplate>
			</template>
			<AddStockTemplate v-on:success="getInventory"></AddStockTemplate>
			<template v-if="checkoutDialog">
				<CheckoutTemplate
					type="Perishable"
					endpoint="inventory"
					:type-uuid="uuid"
					v-on:success="
						checkoutDialog = false;
						getInventory();
					"
					v-on:close="checkoutDialog = false"
					:checkout-dialog="checkoutDialog"
				></CheckoutTemplate>
			</template>
		</template>
		<template v-else>
			<div class="mx-20 my-40 text-center">
				<v-progress-linear color="orange darken-2" indeterminate height="6"></v-progress-linear>
			</div>
		</template>
	</v-sheet>
</template>
<style>
.w-15 {
	width: 125px;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TooltipQuestion from "@/view/components/TooltipQuestion";
import ImageTemplate from "@/view/components/Image";
/* import Barcode from "@/view/components/Barcode"; */
import Comments from "@/view/components/Comments";
import Files from "@/view/components/Files";
import QuantityLocation from "@/view/components/QuantityLocation";
import ReservationListing from "@/view/components/ReservationListing";
import EventListing from "@/view/components/EventListing";
import WorkOrderListing from "@/view/components/WorkOrderListing";
import { GetInventory } from "@/core/lib/inventory.lib";
import ShowValue from "@/view/components/ShowValue";
import AddStockTemplate from "@/view/components/AddStockTemplate";
import { EventBus } from "@/core/event-bus/event.bus";
import DeleteTemplate from "@/view/components/DeleteTemplate";
import RetireTemplate from "@/view/components/RetireTemplate";
import RetireStockTemplate from "@/view/components/RetireStockTemplate";
import ReservationTemplate from "@/view/components/ReservationTemplate";
import RelatedServiceTemplate from "@/view/components/RelatedServiceTemplate";
import SupportTemplate from "@/view/components/SupportTemplate";
import CheckoutTemplate from "@/view/components/CheckoutTemplate";
import ItemRetirementsListing from "@/view/components/ItemRetirementsListing";
import ApiService from "@/core/services/api.service";

export default {
	name: "inventory-detail",
	title: "Detail Perishables",
	data() {
		return {
			inventoryTab: null,
			uuid: null,
			barcode: null,
			deleteText: null,
			deleteURL: null,
			deleteDialog: false,
			checkoutDialog: false,
			retireDialog: false,
			contentLoaded: false,
			retireStockDialog: false,
			reservationDialog: false,
			inventory: {},
			inventorycomment: "0",
			inventoryLog: "0",
			inventoryFile: "0",
			inventoryRetire: "0",
			deviceWidth: document.documentElement.clientWidth,
		};
	},
	created() {
		window.addEventListener("resize", this.resizeEventHandler);
	},
	destroyed() {
		window.removeEventListener("resize", this.resizeEventHandler);
	},
	methods: {
		getInventoryDetailCount() {
			ApiService.setHeader();
			ApiService.get(`inventory-detail-count/${this.inventory.id}`)
				.then(({ data }) => {
					this.inventoryRetire = data.inventoryRetire.toString();
					this.inventoryFile = data.inventoryFile.toString();
					this.inventoryLog = data.inventoryLog.toString();
					this.inventorycomment = data.inventorycomment.toString();
				})
				.catch(() => {});
		},
		resizeEventHandler() {
			this.deviceWidth = document.documentElement.clientWidth;
		},
		doAction(param) {
			switch (param) {
				case "edit":
					this.$router.push({
						name: "inventory-update",
						params: { uuid: this.uuid },
						query: { t: new Date().getTime() },
					});
					break;
				case "duplicate":
					this.$router.push({
						name: "inventory-create",
						query: { duplicate: this.uuid, t: new Date().getTime() },
					});
					break;
				case "delete":
					this.deleteDialog = true;
					break;
				case "retire":
					this.retireDialog = true;
					break;
				case "retire-stock":
					this.retireStockDialog = true;
					break;
				case "add-stock":
					EventBus.$emit("add:stock", { type: "inventory", typeUUID: this.uuid });
					break;
				case "stock-history":
					break;
				case "print-label":
					break;
				case "checkout-history":
					break;
				case "verification-history":
					break;
				case "reserve":
					this.reservationDialog = true;
					break;
				case "checkout":
					this.checkoutDialog = true;
					break;
			}
		},
		getInventory() {
			GetInventory(this.uuid)
				.then((data) => {
					this.barcode = data.barcode;
					this.inventory = data;
					this.getInventoryDetailCount();
					this.deleteText = `#${data.barcode} - ${data.name}`;
					this.deleteURL = `inventory/${data.uuid}`;
					this.$store.dispatch(SET_BREADCRUMB, [
						{ text: "Perishables", disabled: true },
						{ text: "Detail", disabled: true },
						{ text: this.barcode, disabled: true },
					]);
				})
				.catch((error) => {
					this.goBack();
					this.logError(error);
				})
				.finally(() => {
					this.pageLoading = false;
					this.contentLoaded = true;
				});
		},
	},
	components: {
		Files,
		Comments,
		TooltipQuestion,
		QuantityLocation,
		ReservationListing,
		EventListing,
		WorkOrderListing,
		ImageTemplate,
		CheckoutTemplate,
		ShowValue,
		ItemRetirementsListing,
		AddStockTemplate,
		DeleteTemplate,
		RetireTemplate,
		RetireStockTemplate,
		ReservationTemplate,
		RelatedServiceTemplate,
		SupportTemplate,
		//Barcode,
	},
	mounted() {
		this.$store.dispatch(SET_BREADCRUMB, [
			{ text: "Perishables", disabled: true },
			{ text: "Detail", disabled: true },
		]);

		const { uuid } = this.$route.params;
		this.uuid = uuid;
		if (!this.uuid) {
			this.goBack();
		}

		this.getInventory();
	},
	beforeDestroy() {
		this.$store.dispatch(SET_BREADCRUMB, []);
	},
};
</script>
